<template>
    <div class="report-analysis-container" id="reportContainer" v-cloak>
        <div class="report-analysis-header">
            <!--顶部返回按钮-->
            <top-header @refresh-page="refreshPage"></top-header>
            <!-- 成绩分析，答题统计切换 年级选择 -->
            <tab-class-bar></tab-class-bar>
        </div>
        <div class="content-main">
            <div class="report-analysis-main" id="reportMain" :style="{width: tabName==='gradeTab'?'100%':'71.2%'}">
                <template v-if="Object.keys(summaryData).length === 0 && !isShowLoading">
                    <Row :gutter="12" style="margin-bottom: 12px;" class="statistic_wrap">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card class="statistic_card">
                            <p slot="title" class="card-title">
                                年级作业概况
                            </p>
                            <div class="statistic_content_wrap">
                                <!--年级平均分-->
                                <analysis-score-item :type="1"
                                                     :title="'年级平均分'"
                                                     :leftVal="'--'" :rightVal="'--'"></analysis-score-item>
                                <!--年级最高分-->
                                <analysis-score-item :type="2"
                                                     :title="'年级最高分'"
                                                     :leftVal="'--'"></analysis-score-item>
                                <!--年级最低分-->
                                <analysis-score-item :type="3"
                                                     :title="'年级最低分'"
                                                     :leftVal="'--'"></analysis-score-item>
                                <!--平均用时-->
                                <analysis-score-item :type="4"
                                                     :title="'平均用时'"
                                                     :leftVal="'--'"></analysis-score-item>
                                <!--提交人数-->
                                <analysis-score-item :type="5"
                                                     :title="'提交人数'"
                                                     :leftVal="'--'" :rightVal="'--'"></analysis-score-item>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                    <!-- 暂无学生提交-->
                    <Row :gutter="12">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card>
                            <p slot="title" class="card-title">
                            </p>
                            <div class="no-data">
                                <img src="../../../assets/images/product/homework/no-data.png" alt="" class="no_pic">
                                <span class="txt">还没有年级概况统计哦~</span>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                </template>
                <template v-else>
                    <Row :gutter="12" style="margin-bottom: 12px;" class="statistic_wrap">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card class="statistic_card">
                            <p slot="title" class="card-title">
                                年级作业概况
                            </p>
                            <datedu-loading v-if="isShowLoading"></datedu-loading>
                            <div class="statistic_content_wrap" v-if="!isShowLoading">
                                <!--布置作业数-->
                                <analysis-score-item
                                    :title="'年级平均分'"
                                    :type="1"
                                    :leftVal="($utils.toDecimal(summaryData.avgScore)).toString()"
                                    :rightVal="$utils.toDecimal(summaryData.fullScore).toString()"></analysis-score-item>
                                <!--题目数量-->
                                <analysis-score-item
                                    :title="'年级最高分'"
                                    :type="2"
                                    :leftVal="($utils.toDecimal(summaryData.highScore)).toString()"></analysis-score-item>
                                <!--平均提交率-->
                                <analysis-score-item
                                    :title="'年级最低分'"
                                    :type="3"
                                    :leftVal="`${($utils.toDecimal(summaryData.lowerScore)).toString()}`"></analysis-score-item>
                                <!--平均批改率-->
                                <analysis-score-item
                                    :title="'平均用时'"
                                    :type="4"
                                    :leftVal="($utils.convertSecondToTime(summaryData.avgUseTime)).toString()"></analysis-score-item>
                                <analysis-score-item
                                    :title="'提交人数'"
                                    :type="5"
                                    :leftVal="(summaryData.submitStuNum).toString()"
                                    :rightVal="(summaryData.totalStuNum).toString()"></analysis-score-item>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                    <Row :gutter="12" style="margin-bottom: 10px;">
                        <Col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <pie-charts :chartsTitle="'年级成绩分布'"
                                    :isShowMore=false
                                    :isClickCharts=false
                                    :pieChartsName="'成绩分布'"
                                    :chartsId="'hw_grade_score_static'"
                                    :height="'443px'"
                                    :pieRadiusArr="pieRadiusArr"
                                    ref="hwGradeScoreStaticRef">
                        </pie-charts>
                        </Col>
                        <Col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <histogram-charts
                            :chartsTitle="'各班级作业提交率和批改率'"
                            :isShowMore=false
                            :isClickCharts=false
                            :chartsId="'hw_num_day'"
                            :height="'443px'"
                            :histogramTooltip="'hwNumDay'"
                            :colorArr="barColorArr"
                            :fontColor="barFontColor"
                            :isShowDataZoom=true
                            :isDisableDataZoom=false
                            :bottomHeight="'100px'"
                            ref="hwNumDayRef"
                        ></histogram-charts>
                        </Col>
                    </Row>
                    <Row :gutter="12" class="table-list">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card>
                            <p slot="title" class="card-title">
                                班级作答详情
                            </p>
                            <div slot="extra" class="table-list-right-btn">
                                <Button type="ghost" class="table-list-right-btn-download"
                                        @click.native="downloadTableData()">
                                    <i class="export_icon"></i>
                                    导出
                                </Button>
                            </div>
                            <div class="table-content" :style="total && pageCount>1 ? 'padding-bottom: 57px;':''">
                                <div class="header">
                                    <Col :span="2">
                                    <span>序号</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>班级</span>
                                    </Col>
                                    <Col :span="2">
                                    <span>提交人数</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>平均分</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>最高分</span>
                                    </Col>
                                    <Col :span="2">
                                    <span>合格率</span>
                                    </Col>
                                    <Col :span="2">
                                    <span>平均用时</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>授课老师</span>
                                    </Col>
                                    <Col :span="4">
                                    <span>更多</span>
                                    </Col>
                                </div>
                                <div class="row-wrap">
                                    <template v-for="(item,index) in classAnswerDetailList">
                                        <Row :gutter="12" class="row-single"
                                             :class="index % 2 === 0 ? 'row-single':'row-double'">
                                            <Col :span="2">
                                            <span>{{(page - 1) * limit + index + 1}}</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.tea_name}}</span>
                                            </Col>
                                            <Col :span="2">
                                            <span>{{item.subject_name}}</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.class_name}}</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.title}}</span>
                                            </Col>
                                            <Col :span="2">
                                            <span v-if="item.tw_type==0">
                                                自定义
                                            </span>
                                            <span v-else>
                                                题库
                                            </span>
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='101'">-->
                                            <!--同步-->
                                            <!--</span>-->
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='102'">-->
                                            <!--复习-->
                                            <!--</span>-->
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='103'">-->
                                            <!--题库-->
                                            <!--</span>-->
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='104'">-->
                                            <!--校本-->
                                            <!--</span>-->
                                            </Col>
                                            <Col :span="2">
                                            <span>{{$utils.toDecimal(item.subject_Percentage*100)}}%</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.biz_time}}</span>
                                            </Col>
                                            <Col :span="4">
                                            <span>
                                                <Button type="ghost"
                                                        @click="lookAnswerInfo(item.tea_id,item.hw_id,item.title,item.tw_type,item.tw_type)">查看作答详情</Button>
                                            </span>
                                            </Col>
                                        </Row>
                                    </template>
                                </div>
                                <div class="laypage_main">
                                    <Page :total="total" @on-change="handleCurrentChange" :current="page"
                                          v-if="total && pageCount>1"
                                          show-total></Page>
                                </div>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        findTeacherSummary,
        findTeacherHwTypeStatic,
        findTeacherHwNumDayList,
        findTeacherDetailList
    } from "../../../service/bigDataApi.js";
    import {mapGetters} from 'vuex'

    const topHeader = () => import('../../../components/HwAnalysisTopHeader');
    const tabClassBar = () => import('../../../components/HwAnalysisTabClassBar');
    const AnalysisScoreItem = () => import('../../../components/HwAnalysisScoreItem');
    const dateduLoading = () => import('../../../components/DateduLoading');
    const PieCharts = () => import("../../../components/charts/PieCharts.vue");//环形图
    const HistogramCharts = () => import("../../../components/charts/HistogramCharts.vue");//柱状图

    export default {
        name: "teacher-statis",
        data () {
            return {
                isShowLoading: true,//是否显示正在加载动画
                screenWidth: 0,
                tabName: 'gradeTab',
                filters: {
                    // teacherId: this.$route.query.teacherid,
                    teacherId: '46f4a90768ea43ee82a560f9a35f81a5',
                    gradeId: '',
                    subjectId: this.$route.query.subjectid,
                    startDate: this.$route.query.startdate,
                    endDate: this.$route.query.enddate
                },
                summaryData: {
                    avgScore: 80.9,
                    fullScore: 100,
                    highScore: 100,
                    lowerScore: 50,
                    avgUseTime: 943,
                    submitStuNum: 49,
                    totalStuNum: 89
                },//作业概况统计数据
                gradeScoreStatisList: {},//不同类型作业的占比数据
                classSubmitAndCorrectList: [],//每天部署作业数数据
                classAnswerDetailList: [],//作业详细列表数据
                pieRadiusArr: ['50%', '70%'],
                barColorArr: [
                    {offset: 1, color: "#3E73F6"}
                ],
                barFontColor: '#757C8C',
                total: 0,
                page: 1,
                limit: 10, //每页个数
                pageCount: 0
            }
        },
        components: {
            topHeader,
            tabClassBar,
            AnalysisScoreItem,
            dateduLoading,
            PieCharts,
            HistogramCharts
        },
        computed: {
            ...mapGetters([
                'homeWorkReportPath'
            ]),
        },
        methods: {
            /**
             * 获取年级作业概况
             */
            async getGradeSummary () {
                let _this = this;
                // let params = {
                //     teacherid: _this.filters.teacherId,
                //     startdate: _this.filters.startDate,
                //     enddate: _this.filters.endDate,
                // };
                // let resultData = await findTeacherSummary(params).catch(function (error) {
                //     _this.$Message.error(error.message);
                // });
                //
                // if (resultData.length > 0) {
                //     this.summaryData = resultData[0];
                // }
                this.isShowLoading = false;

                _this.$nextTick(() => {
                //获取年级成绩分布
                    this.getGradeScoreStatisList();
                });
            },
            /**
             * 获取年级成绩分布
             */
            async getGradeScoreStatisList () {
                let _this = this;
                // let params = {
                //     teacherid: _this.filters.teacherId,
                //     startdate: _this.filters.startDate,
                //     enddate: _this.filters.endDate
                // };
                // this.gradeScoreStatisList = await findTeacherHwNumDayList(params).catch(function (error) {
                //     _this.$Message.error(error.message);
                // });

                this.gradeScoreStatisList = [
                    {
                        title: '待合格/(0%~59%)',
                        stuNum: 10
                    },
                    {
                        title: '合格/(60%-69%)',
                        stuNum: 32
                    },
                    {
                        title: '良好/(70%~89%)',
                        stuNum: 18
                    },
                    {
                        title: '优秀/(90%~100%)',
                        stuNum: 7
                    }
                ]

                let nameArr = [];
                let dataArr = [];
                for (let i = 0; i < this.gradeScoreStatisList.length; i++) {
                    let obj = {};
                    //处理数据用于渲染图表
                    obj.value = this.gradeScoreStatisList[i].stuNum;
                    obj.name = this.gradeScoreStatisList[i].title;
                    dataArr.push(obj);
                    nameArr.push(this.gradeScoreStatisList[i].title);
                }

                setTimeout(function () {
                    //渲染图表
                    _this.$refs.hwGradeScoreStaticRef.initDataSource(_this.gradeScoreStatisList, nameArr, dataArr);
                }, 300)

                // _this.$nextTick(() => {
                //     //渲染图表
                //     _this.$refs.hwGradeScoreStaticRef.initDataSource(_this.gradeScoreStatisList, nameArr, dataArr);
                // });

                //获取各班级作业提交率和批改率
                this.getClassSubmitAndCorrectStatic();
            },
            /**
             * 获取各班级作业提交率和批改率
             */
            async getClassSubmitAndCorrectStatic () {
                let _this = this;
                // let params = {
                //     teacherid: _this.filters.teacherId,
                //     startdate: _this.filters.startDate,
                //     enddate: _this.filters.endDate
                // };
                // this.classSubmitAndCorrectList = await findTeacherHwTypeStatic(params).catch(function (error) {
                //     _this.$Message.error(error.message);
                // });

                //获取班级作答详情详细列表
                this.getClassAnswerDetailList();

            },

            /**
             * 获取班级作答详情详细列表
             */
            async getClassAnswerDetailList () {
                let _this = this;
                let params = {
                    teacherid: _this.filters.teacherId,
                    startdate: _this.filters.startDate,
                    enddate: _this.filters.endDate
                };
                this.classAnswerDetailList = await findTeacherDetailList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
            },
            /**
             * 导出表格数据
             */
            downloadTableData () {
                // let url =
                //     BASE_URL +
                //     "/homework/statsanalysis/exportWorkScore?workId=" +
                //     this.homeworkId +
                //     "&classId=" +
                //     this.classId;
                // let iframe = document.createElement("iframe");
                // iframe.style.display = "none";
                // iframe.src = url;
                // iframe.onload = function () {
                //     document.body.removeChild(iframe);
                // };
                // document.body.appendChild(iframe);
            },
            /**
             * 刷新页面
             */
            refreshPage () {
                if (this.tabName === 'gradeTab') {
                    // //成绩分析
                    this.getGradeSummary();
                } else {
                    // //答题分析
                    // this.answerStatisticData = [];
                    // this.spinShow = true;
                    //
                    // this.loadAnswerStatistic();
                }
            },
            /**
             * 查看单个作业的作答详情
             */
            lookAnswerInfo (userId, homeworkId, homeworkName, hwType, hwTypeCode) {
                let reportUrl = "";
                //答题卡
                if (hwType == 0) {
                    //web
                    reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                } else if (hwType == 1) {
                    if (hwTypeCode == '103') {
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/jingyouReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                    } else if (hwTypeCode == '104') {
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/xbReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                    } else {
                        //题库
                        reportUrl = this.homeWorkReportPath + '/questionBankReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                    }
                }
                window.open(reportUrl, "_blank");
            },
            /**
             *
             */
            handleCurrentChange (val) {
                this.page = val;
                //根据作业id和班级id获取学生得分列表
                this.getClassAnswerDetailList();
            },
            /**
             * 计算各dom高度
             */
            calDomHeight () {
                let _this = this;
                $(".report-analysis-main").css("height", $(window).height() - 155);
                $(".right-container").css("height", $(window).height() - 155);
                $(".right-container").css("minHeight", $(window).height() - 157);
                $(".question-wrap").css("height", $(window).height() - 155);
                $(".question-wrap").css("minHeight", $(window).height() - 155);
                $(".question-wrap").find('.ivu-card-body').css("minHeight", $(window).height() - 157);
                $(".right-container").find('.ivu-card-body').css("minHeight", $(window).height() - 157);
            },
        },
        mounted () {
            let _this = this;
            //获取屏幕宽度
            this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            this.getGradeSummary();

            _this.$nextTick(() => {
                setTimeout(function () {
                    //动态计算各dom高度
                    _this.calDomHeight();
                }, 300)
            });
            //当浏览器大小变化时
            $(window).resize(function () {
                //动态计算各dom高度
                _this.calDomHeight();
            });
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/product/homework/reportList";
</style>

<style lang="scss">
    @import "../../../style/product/homework/statisMain";
</style>
